import { environment } from '../../../environments/environment';
import { I3AssetsDown } from './models/i3-assets-down.model';
import { I3AssetsMaintenanceDue } from './models/i3-assets-maintenance-due.model';
import { I3AssetsOperatingStatus } from './models/i3-assets-operating-status.model';
import { I3OpenWorkOrders } from './models/i3-open-work-orders.model';
import { Injectable } from '@angular/core';
import { Intelli360ApiService } from './intelli360-api.service';
import { Intelli360TokenInfo } from '../auth/models/Intelli360-token-info.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class Intelli360ManagerService {

    // private demoModeMockDataService: DemoModeMockDataService;

    // =========================================================================================================================================================
    // Ctor
    // =========================================================================================================================================================

    constructor(private intelli360ApiService: Intelli360ApiService) {
        if (environment.isDemoMode) {
            // NOTE: i360 Widgets currently show static image in Demo Mode.

            // this.demoModeMockDataService = AppInjector.get(DemoModeMockDataService);
        }
    }

    // =========================================================================================================================================================
    // Public Methods
    // =========================================================================================================================================================

    getAssetsDown(): Observable<I3AssetsDown> {
        return this.intelli360ApiService.getAssetsDown();
    }

    GetAssetsOperatingStatus(): Observable<I3AssetsOperatingStatus> {
        return this.intelli360ApiService.getAssetsOperatingStatus();
    }

    getMaintenanceDueAssets(): Observable<I3AssetsMaintenanceDue> {
        return this.intelli360ApiService.getMaintenanceDueAssets();
    }

    getOpenWorkOrders(): Observable<I3OpenWorkOrders> {
        return this.intelli360ApiService.getOpenWorkOrders();
    }

    get loginUrl(): string {
        const redirectUrl = encodeURI(window.location.origin);
        return `${environment.intelli360AuthUri}&client_id=${environment.intelli360ClientId}&nonce=defaultNonce&redirect_uri=${redirectUrl}&scope=openid offline_access&response_type=code&prompt=login&state=intelli360`;
    }

    getToken(): Observable<Intelli360TokenInfo> {
        return this.intelli360ApiService.getToken();
    }

    getMyTurfUserName(): Observable<any> {
        // if (environment.isDemoMode) { return of(this.demoModeMockDataService.myTurfUserName); }

        return this.getToken()
            .pipe(
                switchMap((tokenInfo: Intelli360TokenInfo) => {
                    const decodedToken = new JwtHelperService().decodeToken(tokenInfo.token);
                    if (decodedToken == null || decodedToken.emails == null || decodedToken.emails[0] == null ) { return null; }

                    return decodedToken.emails;
                }));
    }

}
